import BigSaleBlock from '../components/Blocks/BigSale/BigSaleBlock';
import CategoriesDealsBlock from '../components/Blocks/CategoriesDeals/CategoriesDealsBlock';
import DoublePushBlock from '../components/Blocks/DoublePush/DoublePushBlock';
import FranchisesBlock from '../components/Blocks/Franchises/FranchisesBlock';
import GamesSliderBlock from '../components/Blocks/GamesSlider/GamesSliderBlock';
import HeroBlock from '../components/Blocks/Hero/HeroBlock';
import HeroSaleBlock from '../components/Blocks/HeroSale/HeroSaleBlock';
import IbexBlock from '../components/Blocks/Ibex/IbexBlock';
import ProductsHighlightsBlock from '../components/Blocks/ProductsHighlights/ProductsHighlightsBlock';
import TriplePushBlock from '../components/Blocks/TriplePush/TriplePushBlock';
import UbisoftPlusBlock from '../components/Blocks/UbisoftPlus/UbisoftPlusBlock';

export const default_blocks_order = [
  "hero_sale",
  "hero",
  "products_highlights",
  "ibex",
  "triple_push_top_sellers",
  "franchises",
  "games_slider",
  "categories_deals",
  "ubisoft_plus",
  "double_push",
  "big_sale"
];

export const blocks = {
  "big_sale": {
    component: BigSaleBlock
  },
  "categories_deals": {
    component: CategoriesDealsBlock
  },
  "double_push": {
    component: DoublePushBlock
  },
  "franchises": {
    component: FranchisesBlock
  },
  "games_slider": {
    component: GamesSliderBlock
  },
  "hero": {
    component: HeroBlock
  },
  "hero_sale": {
    component: HeroSaleBlock
  },
  "ibex": {
    component: IbexBlock
  },
  "products_highlights": {
    component: ProductsHighlightsBlock
  },
  "triple_push": {
    component: TriplePushBlock
  },
  "triple_push_top_sellers": {
    component: TriplePushBlock,
    params: {
      type: "top_sellers"
    }
  },
  "triple_push_farcry": {
    component: TriplePushBlock,
    params: {
      type: "farcry"
    }
  },
  "ubisoft_plus": {
    component: UbisoftPlusBlock
  }
};
